export default __webpack_public_path__ + "static/media/logo2.284feee7.png";